import React, { useState, useEffect } from 'react';
import {
    Grid,
    Paper,
    TextField,
    Button,
    Typography,
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Avatar,
} from '@mui/material';
import globals from '../globals';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingPage from '../error_page/loadingPage';

const preparedQuestions = [
    'Имам нужда от помощ с домашната работа.',
    'Мога ли да отменя среща?',
    'Ще може ли да се уговорим за дата и час за нов урок?'
];

const ChatUI = () => {
    const { token, user } = useAuth();
    const { id } = useParams();
    const [messages, setMessages] = useState([]);
    const [chat, setChat] = useState(null);
    const [input, setInput] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetch(globals.apiUrl + `/courses/chats/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                setChat(data);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }, [id]);

    const handleSend = (text) => {
        if (!text.trim()) return;
        const newMessage = { message: text, user_id: user.id };
        fetch(globals.apiUrl + `/courses/chats/message/${id}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ message: text })
        })
            .then(response => response.json())
            .then(data => {
                // setMessages((prev) => [...prev, newMessage]);
                setChat({ ...chat, messages: [...chat.messages, data] });

                setInput('');
                //console.log(data);
            })
            .catch(error => {
                console.error('Error:', error);
            });

        // Simulate bot response after 1.5s
        // setTimeout(() => {
        //     setMessages((prev) => [
        //         ...prev,
        //         { text: 'Изчакване отговор от учител...', sender: 'bot' },
        //     ]);
        // }, 1500);
    };

    const handleQuickQuestion = (question) => {
        handleSend(question);
    };

    return (
        isLoading ? <LoadingPage /> :
            <Grid container spacing={2}>
                {/* Chat Area */}
                <Grid item xs={12} sm={9}>
                    <Paper elevation={3} sx={{ p: 2, height: '80vh', display: 'flex', flexDirection: 'column' }}>
                        {/* Messages */}
                        <Box sx={{ flexGrow: 1, overflowY: 'auto', mb: 2 }}>
                            {chat.messages.map((msg, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: msg.user_id === user.id ? 'flex-end' : 'flex-start',
                                        mb: 1,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            px: 2,
                                            py: 1,
                                            borderRadius: 2,
                                            maxWidth: '70%',
                                            backgroundColor: msg.user_id === user.id ? globals.colors.lightPink : globals.colors.lightBlue,
                                            color: msg.user_id === user.id ? globals.colors.textColor : globals.colors.backgroundColor,
                                        }}
                                    >
                                        {msg.message}
                                    </Box>
                                </Box>
                            ))}
                        </Box>

                        {/* Input Field */}
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <TextField
                                variant="outlined"
                                placeholder="Напиши съобщение..."
                                fullWidth
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') handleSend(input);
                                }}
                                sx={{
                                    borderRadius: 1,
                                    backgroundColor: globals.colors.lightPink, // default background
                                    '&:hover': {
                                        backgroundColor: globals.colors.lightPink, // no color on hover
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: 'transparent', // no border by default
                                        },
                                        '&:hover fieldset': {
                                            borderColor: 'transparent', // no border on hover
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: globals.colors.lightRed, // red border when typing
                                        },
                                    },
                                }}
                            />
                            <Button
                                variant="contained"
                                sx={{ backgroundColor: globals.colors.lightRed, '&:hover': { backgroundColor: globals.colors.darkRed }, }}
                                onClick={() => handleSend(input)}
                            >
                                Изпрати
                            </Button>
                        </Box>
                    </Paper>
                </Grid>

                {/* Quick Questions */}
                <Grid item xs={12} sm={3} textAlign={'center'}>
                    <Paper elevation={3} sx={{ p: 2, height: '80vh', display: 'flex' }} flexDirection='column' >


                        <Grid container direction={'column'}>
                            <Grid item sx={{ flexGrow: 1 }}>
                                {chat.student_id == user.id &&
                                    <>
                                        <Typography sx={{ fontSize: 20, color: globals.colors.darkBlue, fontWeight: 'bold' }}>
                                            Избери тема за разговор
                                        </Typography>
                                        <List>
                                            {preparedQuestions.map((question, index) => (
                                                <Box sx={{
                                                    backgroundColor: globals.colors.darkBlue, borderRadius: 3, m: 2, '&:hover': {
                                                        backgroundColor: globals.colors.lightBlue,
                                                    },
                                                }}>
                                                    <ListItem key={index} disablePadding>
                                                        <ListItemButton onClick={() => handleQuickQuestion(question)}>
                                                            <ListItemText primary={question} sx={{ color: globals.colors.backgroundColor }} />
                                                        </ListItemButton>
                                                    </ListItem>
                                                </Box>
                                            ))}
                                        </List>
                                    </>}


                                <Grid item sx={{ mt: 'auto', pt: 2 }}>
                                    <Grid container >
                                        <Grid item >
                                            <Avatar src={chat.student_image_url} sx={{ height: 70, width: 70 }} />
                                        </Grid>
                                        <Grid item sm={8} sx={{ mx: 1, mt: 1 }}>
                                            <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold' }}>{chat.student_name}</Typography>
                                            <Typography sx={{ fontSize: 13 }}>
                                                {chat.course_title}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid >
    );
};

export default ChatUI;
